<template>
  <div id="overlay">
    <component :is="overlayReference" :overlay="overlay"></component>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Overlay',
  computed: {
    ...mapState('ui', ['overlay']),
    overlayReference() {
      return () => import(`@/components/overlay/${this.overlay.component}Overlay.vue`)
    },
  },
}
</script>

<style lang="scss" scoped>
#overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;

  display: flex;
  justify-content: center;
  align-items: center;

  &:before {
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 1);
  }

  > * {
    z-index: 2;
    position: relative;
  }
}
</style>
